import React from "react";
import {readableDate} from "../../utils";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";


export default function InspectionApproveRow({inspection, index, onChange}){



    return (
        <tr>
            <td>{inspection.inspection_type}</td>
            <td>{readableDate(inspection.expiry_date)}</td>
            <td>{readableDate(inspection.date_completed)}</td>
            <td>
                {useEditableTableDateCell({
                    propName: "new_expiry_date",
                    value: inspection.new_expiry_date,
                    onChange: (e) => onChange(e, index),
                    editable: true,
                    inlineEdit: false
                })}
            </td>
            <td>
                {useEditableTableDateCell({
                    propName: "new_completed_date",
                    value: inspection.new_completed_date,
                    onChange: (e) => onChange(e, index),
                    editable: true,
                    inlineEdit: false
                })}
            </td>
        </tr>
    )

}